<div class="sidebar mx-2 ml-5">
  <div [ngClass]="{ '': !showRow, 'flex-row': showRow }">
    <div
      [ngClass]="{ row: !showRow, 'col-6': showRow }"
      class="outer_card side-welcome-container"
    >
      <div class="card welcome-container">
        <!-- card-body -->
        <div class="">
          <p class="mb-1 user-tag">
            <span
              class="badge background_color_1"
              style="color: #151515; margin: auto"
              >{{ role }}</span
            >
          </p>
          <h6 class="card-title mb-1">
            👋🏼 <span class="title_header">Welcome Back</span
            ><span class="title_header_2"
              >,
              {{
                userName.length > 15 ? userName.slice(0, 15) + "..." : userName
              }}</span
            >
          </h6>
          <!-- <p class="card-text title_header_1"> You are the <span class="title_header_2">{{role | titlecase}}</span></p> -->
          <p class="card-text title_header_1">
            {{ today | date : "dd MMMM, yyyy - EEEE" }}
          </p>
        </div>
      </div>
    </div>

    <!-- wallet -->
    <div
      [ngClass]="{ row: !showRow, 'col-6': showRow }"
      class="outer_card side-wallet-container"
    >
      <div class="wallet-container">
        <!-- Tab Header -->
        <div class="tab-header">
          <button
            class="tab-button"
            [class.active]="tabIndex === 0"
            (click)="tabIndex = 0"
          >
            <span>Wallet</span>
          </button>
          <button
            class="tab-button"
            [class.active]="tabIndex === 1"
            (click)="tabIndex = 1"
          >
            <span>Inventory</span>
          </button>
        </div>

        <!-- Content Area -->
        <div class="wallet-content">
          <!-- Wallet Tab -->
          <div class="balance-section" *ngIf="tabIndex === 0">
            <div class="balance-header">
              <div class="balance-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#722C60"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-wallet"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
                  />
                  <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
                </svg>
                <span>Wallet Balance</span>
              </div>
              <div class="balance-amount">
                <span class="currency">₹</span>
                <span class="amount">{{ diaplybalance | number }}</span>
              </div>
            </div>
            <!-- "View More" opens the VAN wallet detail page; hidden for UTR
                 (no-VAN) wallets, which have no such page. -->
            <div class="balance-actions-wallet" *ngIf="!isUtrWallet">
              <button class="action-btn view-more" (click)="viewMore()">
                View More
                <i class="pi pi-external-link"></i>
              </button>
            </div>
          </div>

          <!-- Inventory Tab -->
          <div class="balance-section" *ngIf="tabIndex === 1">
            <div class="balance-header">
              <div class="balance-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#722C60"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-wallet"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
                  />
                  <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
                </svg>
                <span>Inventory Balance</span>
              </div>
              <div class="balance-amount">
                <span class="currency">₹</span>
                <span class="amount">{{
                  diaplybalance | number : "1.0-0"
                }}</span>
              </div>
            </div>
            <div class="balance-actions">
              <div class="alert-left">
                <div class="warning-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                    />
                  </svg>
                </div>
                <span class="alert-text">Low Balance</span>
              </div>
              <div>
                <button
                  class="action-btn view-more"
                  (click)="viewMoreInventory()"
                >
                  View More
                  <i class="pi pi-external-link"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->

  <!-- pending Activities -->
  <div class="row outer_card side-action-container">
    <div class="card welcome-container pending-actions-container">
      <!-- card-body -->
      <div class="pending-action-container">
        <div class="pending-action-title-container">
          <h5 class="card-title title_header">Pending Activities</h5>
          <!-- <h5 class="card-title title_header  clickable" style=" background-color: var(--theme-color-faint-30);
          border-radius: 1rem;
          text-align: center;
          max-height: 2.5rem;
          padding: 5px 10px !important;" (click)="gotoOrderListing()"> Count - {{totalRecords}}</h5>-->
        </div>

        <div class="action-container">
          <ng-container *ngIf="pendingOrderDetils.length === 0">
            <div>
              <span colspan="8" style="text-align: center; font-size: 1rem"
                >No recent Activity
              </span>
            </div>
          </ng-container>
          <div
            class="outer_card_0 actions"
            *ngFor="let order of pendingOrderDetils; let i = index"
          >
            <div class="card mt-1">
              <div
                class="mt-1 clickable"
                (click)="getOrderType(order.bulk_order, order)"
              >
                <div class="row">
                  <div class="col-lg-6 col-sm-6 col-md-6">
                    <h6
                      class="card-subtitle title_header_0 badge bg-light text-dark"
                    >
                      Order ID:
                      <span
                        *ngIf="order.bulk_order == null; else showBulkOrderId"
                        >{{ order.id }}</span
                      >
                      <ng-template #showBulkOrderId>{{ order.id }}</ng-template>
                    </h6>
                  </div>
                  <div class="col-lg-6 col-sm-6 col-md-6 text-right">
                    <span class="date text-dark pt-1"
                      >{{ order.created | date : "dd MMM yyyy" }}
                    </span>
                  </div>
                </div>
                <p class="card-text mt-3">
                  {{ order.order_type }} | {{ order.status }} |
                  {{ order.branch }} |
                  <span *ngIf="order.bulk_order"
                    ><b>Bulk Id : </b> {{ order.bulk_order }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="text-right p-3">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="text-center pb-5">
        <div>
          <img
            src="../../../../assets/img/admin-notified.jpg"
            width="45"
            class="logo_style_0"
          />
        </div>
        <p class="pop_style">Admin notified successfully!</p>
        <div>
          <p>A notification email has been sent to your admin</p>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</div>
